var Animator      = require("enyo-anim/Animator"),
    Attractor     = require("enyo-anim/Attractor"),
    Page          = require("ott/image-reader/Page"),
    Scalar        = require("enyo-anim/Scalar"),
    get           = require("object-path").get,
    kind          = require("enyo/kind"),
    quickMacroize = require("enyo/macroize").quickMacroize,
    themeVars     = require("app/theme/variables.js"),
    global        = require("app/utils/global");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageReader.Page.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.Page",

    /**
     * @private
     */
    kind: Page,

    /**
     * Init imageOpacity animator.
     *
     * @memberof enyo-ui.FadeSupport
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.imageOpacity = new Animator({
                scalar: new Scalar({
                    value:   this.initialOpacity,
                    epsilon: 0.01
                }),
                attractors: {
                    target: new Attractor({
                        attraction: 0.02
                    })
                }
            });
            sup.apply(this, arguments);
        };
    }),

    /**
     * @private
     */
    dataChanged: kind.inherit(function(sup) {
        return function() {
            var data         = this.data,
                imageOpacity = this.imageOpacity,
                image        = this.image;

            sup.apply(this, arguments);

            if (!data) {
                return;
            }

            if (!image) {
                image = this.image = new global.Image();

                // Reveal image
                image.onload = image.onerror = this.bindSafely(function() {
                    this.set("dirty", true);

                    // If the page is already visible without the image, fade it
                    // in.
                    if (this.transform.isVisible()) {
                        imageOpacity.attractors.target.value = 1;
                    }

                    // If the page is invisible, lets just be lazy and set it to
                    // full opacity.
                    else {
                        imageOpacity.clearAttractors();
                        imageOpacity.snapToValue(1);
                    }
                });
            }

            // Hide image and set new source
            imageOpacity.clearAttractors();
            imageOpacity.snapToValue(0);
            image.src = data.url;
        };
    }),

    /**
     * Update the image opacity too.
     *
     * @public
     */
    updateState: kind.inherit(function(sup) {
        return function() {
            this.updateImageOpacity();
            sup.apply(this, arguments);
        };
    }),

    /**
     * Update the image opacity.
     *
     * @private
     */
    updateImageOpacity: function() {
        var imageOpacity = this.imageOpacity;

        imageOpacity.update();

        // Animation is finished
        if (imageOpacity.isDone()) {
            imageOpacity.finish();
        }
    },

    /**
     * Makes a new snapshot of the current state of the page and stores it
     *
     * @return  {Object}  The new state
     * @private
     */
    buildState: kind.inherit(function(sup) {
        return function() {
            var state;

            state              = sup.apply(this, arguments);
            state.imageOpacity = this.imageOpacity.scalar.value;

            return state;
        };
    }),

    /**
     * @param  {CanvasRenderingContext2D}  context  The rendering context
     * @public
     */
    draw: function(context) {
        var transform     = this.transform,
            bounds        = transform.calcBounds(),
            clippedBounds = transform.calcClippedBounds(),
            scaleX        = transform.animators.scaleX.scalar.value,
            scaleY        = transform.animators.scaleY.scalar.value,
            image         = this.image;

        if (bounds && clippedBounds) {

            // Draw a rectangle the size of the page
            context.beginPath();
            context.globalAlpha              = 1;
            context.globalCompositeOperation = "source-over";
            context.fillStyle                = quickMacroize("hsla({$h}, {$s}%, {$l}%, {$a})", {
                h: get(themeVars, "placeholderColor.h", 0),
                s: get(themeVars, "placeholderColor.s", 0),
                l: get(themeVars, "placeholderColor.l", 0),
                a: get(themeVars, "placeholderColor.a", 0)
            });
            context.fillRect(
                Math.round(bounds.x),
                Math.round(bounds.y),
                Math.round(bounds.width),
                Math.round(bounds.height)
            );

            // Draw the image if it's loaded
            if (image && image.width && image.height) {
                context.globalAlpha              = this.imageOpacity.scalar.value;
                context.globalCompositeOperation = "source-over";
                context.drawImage(
                    image,
                    Math.round((clippedBounds.x - bounds.x) * (1 / scaleX)),
                    Math.round((clippedBounds.y - bounds.y) * (1 / scaleY)),
                    Math.round(clippedBounds.width * (1 / scaleX)),
                    Math.round(clippedBounds.height * (1 / scaleY)),
                    Math.round(clippedBounds.x),
                    Math.round(clippedBounds.y),
                    Math.round(clippedBounds.width),
                    Math.round(clippedBounds.height)
                );
            }

        }
    },

    /**
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.set("isLoading", false);
        };
    })

});
